import FrequencyTrendSignals from "./frequencyTrendSignals/FrequencyTrendSignalsModule";
import TrendAssetSelector from "./trendAssetsSelector/TrendAssetsSelectorModule";
import TrendSignalSettings from "./trendSignalSettings/TrendSignalSettingsModule";
import AdvancedSettingsDrawer from "./advancedSettingsDrawer/AdvancedSettingsDrawerModule";
import TrendMenuActions from "./TrendMenuActions";
import TrendMenuMutations from "./TrendMenuMutations";

const state = { trendChartModel: {} };

const { actions } = TrendMenuActions;

const { mutations } = TrendMenuMutations;

const namespaced = true;

export default {
	state,
	actions,
	mutations,
	namespaced,
	modules: {
		TrendAssetSelector,
		TrendSignalSettings,
		FrequencyTrendSignals,
		AdvancedSettingsDrawer
	},
};